import React from 'react';
import { cn } from '../../../lib/utils';

/**
 * PhoneMockup - A Kibo UI component for displaying content in a mobile device frame
 * 
 * @param {React.ReactNode} children - Content to display inside the phone frame
 * @param {string} className - Additional CSS classes
 * @param {number} height - Height of the screen area (default: 640)
 * @param {boolean} showStatusBar - Whether to show the status bar (default: true)
 */
export const PhoneMockup = ({ 
  children, 
  className = '', 
  height = 640,
  showStatusBar = true 
}) => {
  return (
    <div className={cn("relative bg-gray-800 dark:bg-gray-900 rounded-[2.5rem] p-2 shadow-2xl", className)}>
      {/* Bezel/Frame */}
      <div className="bg-black dark:bg-gray-950 rounded-[2rem] overflow-hidden border-2 border-gray-700 dark:border-gray-600">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-5 bg-black dark:bg-gray-950 rounded-b-2xl z-20"></div>
        
        {/* Status Bar */}
        {showStatusBar && (
          <div className="h-7 bg-black flex items-center justify-between px-5 pt-1.5 relative z-10">
            <div className="flex items-center gap-0.5">
              <div className="w-1 h-1 bg-white rounded-full"></div>
              <div className="w-1 h-1 bg-white rounded-full"></div>
              <div className="w-1 h-1 bg-white/60 rounded-full"></div>
            </div>
            <div className="text-[9px] text-white font-semibold">9:41</div>
            <div className="flex items-center gap-1">
              <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 13a3 3 0 100-6 3 3 0 000 6z" />
              </svg>
              <div className="relative w-4 h-2 border border-white rounded-sm">
                <div className="absolute left-0.5 top-0.5 bottom-0.5 w-3 bg-white rounded-sm"></div>
              </div>
            </div>
          </div>
        )}
        
        {/* Screen Content */}
        <div className="bg-background" style={{ height: `${height}px`, maxHeight: `${height}px` }}>
          <div className="h-full overflow-auto">
            {children}
          </div>
        </div>
        
        {/* Home Indicator */}
        <div className="h-1 bg-white/30 rounded-full w-32 mx-auto mb-3"></div>
      </div>
    </div>
  );
};

export default PhoneMockup;

